import { useState, useEffect } from "react";
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";

interface SessionPopupProps {
  isModalVisible: boolean;
  setModalVisibility: (isVisible: boolean) => void;
  handleLogout: () => void;
  handleExtend: (renewNow: boolean) => void;
  warningTime: number;
}

function SessionPopup({
  warningTime,
  isModalVisible,
  setModalVisibility,
  handleLogout,
  handleExtend,
}: SessionPopupProps) {
  const [time, setTime] = useState(warningTime); // initial time in seconds
  const { t } = useTranslation();
  const sessionExpiration = sessionStorage.getItem("sessionExpiration") || "";

  useEffect(() => {
    setTime(warningTime);
  }, [handleExtend, warningTime]);

  useEffect(() => {
    let timer: number;
    if (isModalVisible) {
      const sessionExpirationInSeconds =
        new Date(sessionExpiration).getTime() / 1000;
      timer = window.setInterval(() => {
        setTime(Math.round(sessionExpirationInSeconds - Date.now() / 1000));
      }, 1000);
    }
    return () => window.clearInterval(timer);
  }, [isModalVisible, sessionExpiration]);

  useEffect(() => {
    const diff = new Date(sessionExpiration).getTime() - Date.now();
    // less than 0 seconds of session time left
    if (diff <= 0) {
      console.log("less than 0 seconds of session time left");
      handleLogout();
      setModalVisibility(false);
    }
  }, [sessionExpiration, handleLogout, setModalVisibility]);

  const displayedTime =
    time > 60
      ? `${Math.floor(time / 60)} minutes ${time % 60} seconds`
      : `${time} seconds`;

  return (
    <MotifModal
      show={isModalVisible}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
      onClose={() => {
        handleExtend(true);
        setModalVisibility(false);
      }}
    >
      <MotifModalHeader className="session-popup">
        {t("global.globalNotifications.sessionExpiresSoon")}
      </MotifModalHeader>
      <MotifModalBody>
        <p>
          {t("global.globalNotifications.extendSessionDescription1", {
            time: displayedTime,
          })}
        </p>
        <p>{t("global.globalNotifications.extendSessionDescription2")}</p>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          size="medium"
          type="button"
          onClick={() => {
            handleExtend(true);
            setModalVisibility(false);
          }}
        >
          {t("global.globalActions.extendSession")}
        </MotifButton>
        <MotifButton
          size="medium"
          variant="secondary"
          type="button"
          onClick={() => {
            handleLogout();
            setModalVisibility(false);
          }}
        >
          {t("global.globalActions.logOutNow")}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}

export default SessionPopup;
